/* Config */
var phoneBreakpoint = 500;
var tabletBreakpoint = 768;

var isMobile,
    isTablet,
    isPhone,
    isTouch;

$(document).ready(function () {
    deviceCheck();
    changeEvents();
    responsiveVideoEmbed();
    tabbedContentBlock();
    accessibility();
    sectionToggle();
    radDropDownMaxWidth();
    formUX();
    accordion();
    sectionMenuTabs();
    initTrainingWizard();
    var primaryAcc = dashboardAccordions()
    if (document.getElementsByClassName("c-accordion").length > 0) accordionActivateItem(primaryAcc);
    if (document.getElementsByClassName("side-menu-items--name").length > 0) collapseState();
    if (document.getElementsByClassName("c-general-accordion").length > 0) pageAccordions();
    if (document.getElementsByClassName("c-file-upload").length > 0) uploader.init();
    if (document.getElementsByClassName("carousel").length > 0) carousel();
});

document.addEventListener("DOMContentLoaded", () => {
    const path = window.location.pathname || "";
    const segments = path.split("/").filter(Boolean);
    const firstSegment = (segments[0] || "").toLowerCase();

    const langMap = new Map([
        ["en", "en-GB"],
        ["cym", "cy-GB"],
        ["cy", "cy-GB"],
    ]);

    const lang = langMap.get(firstSegment) || "en-GB"; // default if no language segment present

    document.documentElement.setAttribute("lang", lang);
});